module.exports = __webpack_public_path__ + "static/media/pic1.ff45bb79.webp";